import { BOOLEAN_SELECT_LIST_ITEMS, Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import { ProviderFilter as ProviderFilterModel, ProviderFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const ProviderFilter = (props: {
  filter: ProviderFilterModel;
  setFilter: (filter: ProviderFilterModel) => void;
}) => {
  const { breakpointsRef, largeFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<ProviderFilterResource>({} as ProviderFilterResource);
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.providers.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const isActiveField = () => {
    const propertyName = pn<ProviderFilterModel>("isActive");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={BOOLEAN_SELECT_LIST_ITEMS.find((x) => x.id === props.filter.isActive)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.isActive = value?.id;
            })
          )
        }
      />
    );
  };

  const regionField = () => {
    const propertyName = pn<ProviderFilterModel>("regionIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.regions?.filter((x) => props.filter.regionIds?.includes(x.id))}
        options={resource.regions}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.regionIds = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  const districtField = () => {
    const propertyName = pn<ProviderFilterModel>("districtIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.districts?.filter((x) => props.filter.districtIds?.includes(x.id))}
        options={resource.districts}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.districtIds = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  const schoolField = () => {
    const propertyName = pn<ProviderFilterModel>("schoolIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.schools?.filter((x) => props.filter.schoolIds?.includes(x.id))}
        options={resource.schools}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolIds = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={largeFieldBreakpoints}>
        {isActiveField()}
      </Grid>

      {resource.canAccessRegionFilter && (
        <Grid item xs={largeFieldBreakpoints}>
          {regionField()}
        </Grid>
      )}

      {resource.canAccessDistrictFilter && (
        <Grid item xs={largeFieldBreakpoints}>
          {districtField()}
        </Grid>
      )}

      {resource.canAccessSchoolFilter && (
        <Grid item xs={largeFieldBreakpoints}>
          {schoolField()}
        </Grid>
      )}
    </Grid>
  );
};
